import React from 'react';

export const TwitterSvg: React.FC = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={15}
      height={12}
      fill='none'
    >
      <g>
        <path
          fill='#040325'
          d='M13.903 1.682a5.198 5.198 0 0 1-.663.241c.268-.303.473-.66.597-1.05a.221.221 0 0 0-.323-.257c-.481.285-1 .49-1.543.61A2.947 2.947 0 0 0 6.99 3.71 7.537 7.537 0 0 1 1.816.965a.22.22 0 0 0-.363.028 2.943 2.943 0 0 0 .302 3.389 2.494 2.494 0 0 1-.394-.176.221.221 0 0 0-.329.188v.04c0 1.058.57 2.012 1.441 2.531a2.54 2.54 0 0 1-.224-.032.221.221 0 0 0-.252.285 2.943 2.943 0 0 0 2.157 1.973 5.208 5.208 0 0 1-2.784.794c-.209 0-.419-.012-.624-.036a.221.221 0 0 0-.145.406 7.94 7.94 0 0 0 4.293 1.258c2.998 0 4.873-1.413 5.918-2.599 1.303-1.479 2.05-3.436 2.05-5.37 0-.08 0-.162-.003-.243a5.724 5.724 0 0 0 1.317-1.395.221.221 0 0 0-.274-.325Z'
        />
      </g>
      <defs>
        <clipPath id='a'>
          <path
            fill='#fff'
            d='M.5 0h13.714v12H.5z'
          />
        </clipPath>
      </defs>
    </svg>
  );
};
